import { render } from "./RemoveMember.vue?vue&type=template&id=0aa18cc1"
import script from "./RemoveMember.vue?vue&type=script&lang=js"
export * from "./RemoveMember.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__